/* 自定义微信插件 */
export default {
  /* 
  //将方法添加到Vue实例上
   install: (Vue, options) => {
     Vue.prototype.$wxHideOptionMenu = () => wxHideOptionMenu();
   }, 
   */
  /**
   * 隐藏微信分享、链接等事件
   */
  wxHideOptionMenu() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      if (typeof WeixinJSBridge == 'undefined') {
        //微信浏览器内置对象。参考微信官方文档
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu')
          }, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu')
          });
          document.attachEvent('onWeixinJSBridgeReady', function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu')
          });
        }
      } else {
        WeixinJSBridge.call('hideOptionMenu');
      }
    }
  }
}
